import { Component, Input, ElementRef } from '@angular/core';
import { EventsProvider } from '../../providers/events/events';
import moment from 'moment';
import { AppState } from '../../config/state';
import { AppBlock } from '../../providers/config/config';

/**
 * Generated class for the CoAttendComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-attend',
  templateUrl: 'co-attend.html'
})
export class CoAttendComponent {
  @Input() locationId: number;
  @Input() mode: string;
  @Input() cssRules: any = {};
  @Input() blockSettings: AppBlock;
  events: Array<any> = [];
  constructor(private el:ElementRef, private eventsProvider:EventsProvider, private state: AppState) {
  }

  ngOnInit() {
    if (!this.locationId && this.state.locationId) {
      this.locationId = this.state.locationId;
      // console.log(this.state.locationId);
    }
    if (this.locationId){
      this.eventsProvider.getEvents(`startDate: "${moment().startOf('day').format("YYYY-MM-DD HH:mm:ss")}", endDate: "${moment().add(7, 'day').endOf('day').format("YYYY-MM-DD HH:mm:ss")}", locationId: ${this.locationId}`).then(events=>{
        this.events = events.allEvents;
      })
    } else {
      this.eventsProvider.getEvents(`startDate: "${moment().startOf('day').format("YYYY-MM-DD HH:mm:ss")}", endDate: "${moment().add(7, 'day').endOf('day').format("YYYY-MM-DD HH:mm:ss")}"`).then(events=>{
        this.events = events.allEvents;
      })
    }
  }

  ngAfterViewInit(){
    if(this.cssRules){
      Object.keys(this.cssRules).forEach((key) => {
        let value = this.cssRules[key];
//        this.el.nativeElement.style[key]=value;
        this.el.nativeElement.style.setProperty(key, value, 'important');
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/co-attend/co-attend.ts